import React from"react";// @ts-ignore-next-line
import styles from"./H3.module.scss";export var H3=function H3(_ref){var children=_ref.children;return/*#__PURE__*/React.createElement("h3",{className:styles.h3},children);};